import api from "./api";

const adminRouteAccessApi = {
    logRouteAccess: (routePath) => {
        const url = '/admin/route-access/log';
        return api.post(url, { routePath });
    },
    getTopRoutes: (count = 5) => {
        const url = `/admin/route-access/top?count=${count}`;
        return api.get(url);
    }
};

export default adminRouteAccessApi;
